import { Observable } from 'rxjs';
import { GLSLocation } from '../domain/models/gls-location';
import { PublicLocationSequenceUpdateRequest } from '../domain/models/public-location-job-sequence-update';
import { BaseResponse } from '../../data/shared/base.response';

export abstract class PublicLocationsRepository {
  abstract getPublicLocationsByJobId(jobId: string): Observable<GLSLocation[]>;
  abstract getPublicLocationsBySegmentId(jobId: string): Observable<GLSLocation[]>;
  abstract getUnAssignedPublicLocationsByPlanId(
    planId: string
  ): Observable<GLSLocation[]>;
  abstract updatePublicLocationSequence(
    locations: PublicLocationSequenceUpdateRequest[]
  ): Observable<boolean>;
}
